import { register ,callOperation} from "async-ops";
import { callMvcApi  } from "../../../call-web-api";
import { getDefaultOptions } from "../../../utils/fetch";
import mdaeNotfy, { NOTIFY_MESSAGE_TYPE } from "../../../common_components/common_widgets/toast/notify";

export const DELETE_CATEGORY = 'DELETE_CATEGORY';

export const service = async (data,dispatch) => {
  const options: object = {
    url:  '/Api/CategoryManagement/DeleteCategory',
    method: "POST",
    ...getDefaultOptions(),
    body: JSON.stringify(data)
  }
  const response = await callMvcApi(options);
  if (response !== 0) {
    mdaeNotfy({ message: data.categoryName + " Deleted Succesfully!", messageType: NOTIFY_MESSAGE_TYPE.SUCCESS })
  }
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(DELETE_CATEGORY, service, mock);
